import { render, staticRenderFns } from "./JobDetailStats.vue?vue&type=template&id=7cd82bd9&scoped=true"
import script from "./JobDetailStats.vue?vue&type=script&lang=js"
export * from "./JobDetailStats.vue?vue&type=script&lang=js"
import style0 from "./JobDetailStats.vue?vue&type=style&index=0&id=7cd82bd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd82bd9",
  null
  
)

export default component.exports